import google, { mutators, noPrintClass, removeMapControl, repositionMapControl, verify } from "@churchofjesuschrist/maps-google";
import { classNames, controlClass, css, proxy, removeListeners, removeUndefined, styleClass } from "@churchofjesuschrist/maps-utils";
import OverviewMap from "@churchofjesuschrist/maps-google-overview";
let initialized = false;
const defaultOptions = {};
class OverviewControl {
  constructor(options = {}) {
    if (!initialized) {
      verify();
      construct();
      initialized = true;
    }
    this.setOptions({
      ...defaultOptions,
      ...removeUndefined(options)
    });
  }
}
const construct = () => {
  Object.assign(defaultOptions, {
    mapTypeId: google.maps.MapTypeId.SATELLITE,
    position: google.maps.ControlPosition.RIGHT_BOTTOM,
    size: new google.maps.Size(80, 80)
  });

  // grey2
  const canvasClass = styleClass("google-overview-control", null, controlClass())`
        background: #ffffff;
        border: 2px solid #f7f8f8;
        border-radius: 4px;
    `;
  const labelClass = styleClass("google-overview-control", "label")`
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 33px;
        width: 100%;
        z-index: 1;
        text-indent: 6px;
        line-height: 40px;
        color: #ffffff;
        font-size: 11px;
        text-shadow: 0 1px 8px rgba(0,0,0,.7);
        background: linear-gradient(to bottom, transparent, rgba(0,0,0,.6));
        pointer-events: none;
        overflow: hidden;
        text-overflow: ellipsis;
    `;
  Object.setPrototypeOf(OverviewControl.prototype, Object.assign(new google.maps.MVCObject(), mutators("mapTypeId", "text", "map"), (() => {
    function onAdd() {
      let map = this.getMap();
      if (this.$map !== map) {
        onRemove.call(this);
        this.$map = map;
        if (!this.$div) {
          this.$div = document.createElement("div");
        }
        updateClassName.call(this);
        updateSize.call(this);
        updatePosition.call(this);
        if (!this.$overview) {
          this.$overview = new OverviewMap(this.$div, {
            mapTypeId: this.getMapTypeId(),
            map
          });
        }
        updateText.call(this);
        updateCursor.call(this);
        updateTitle.call(this);
        this.$listeners = [this.$overview.addListener("click", proxy(forwardClick, this))];
        this.$overview.bindTo("mapTypeId", this);
      }
    }
    function onRemove() {
      removeMapControl(this.$map, this.$div);
      delete this.$map;
      if (this.$overview) {
        this.$overview.unbindAll();
      }
      if (removeListeners(this.$listeners)) {
        delete this.$listeners;
      }
    }
    function updatePosition() {
      let position = this.get("position");
      repositionMapControl(this.getMap(), this.$div, position);
    }
    function updateClassName() {
      if (this.$div) {
        let className = this.get("className");
        this.$div.className = classNames(className, canvasClass, noPrintClass);
      }
    }
    function updateSize() {
      let size = this.get("size");
      if (size) {
        css(this.$div, {
          width: size.width + "px",
          height: size.height + "px"
        });
        if (this.$overview) {
          google.maps.event.trigger(this.$overview, "resize");
        }
      }
    }
    function updateText() {
      if (this.$div) {
        let text = this.get("text");
        if (text) {
          if (!this.$label) {
            this.$label = document.createElement("span");
            this.$label.className = labelClass;
            this.$div.appendChild(this.$label);
          }
          this.$label.innerHTML = text;
        } else {
          if (this.$label) {
            this.$label.parentNode.removeChild(this.$label);
            delete this.$label;
          }
        }
      }
    }
    function updateCursor() {
      if (this.$overview) {
        this.$overview.set("draggableCursor", this.get("cursor") || "pointer");
      }
    }
    function updateTitle() {
      if (this.$overview) {
        let title = this.get("title");
        if (title) {
          this.$overview.getDiv().title = title;
        } else {
          this.$overview.getDiv().removeAttribute("title");
        }
      }
    }
    function forwardClick() {
      google.maps.event.trigger(this, "click");
    }
    return {
      getDiv: function () {
        return this.$div;
      },
      changed: function (key) {
        switch (key) {
          case "map":
            if (this.getMap()) {
              onAdd.call(this);
            } else {
              onRemove.call(this);
            }
            break;
          case "position":
            updatePosition.call(this);
            break;
          case "className":
            updateClassName.call(this);
            break;
          case "size":
            updateSize.call(this);
            break;
          case "text":
            updateText.call(this);
            break;
          case "cursor":
            updateCursor.call(this);
            break;
          case "title":
            updateTitle.call(this);
            break;
        }
      }
    };
  })()));
};
export default OverviewControl;